// A deploy changes the hashed chunk names, so a tab still running the previous build
// requests a chunk that no longer exists. The static host answers with index.html,
// and each engine reports the failed lazy import differently.
const CHUNK_LOAD_ERROR_MESSAGES = [
  'Loading chunk',
  'error loading dynamically imported module',     // Firefox
  'Failed to fetch dynamically imported module',   // Chromium
  'is not a valid JavaScript MIME type',           // WebKit (Safari and every iOS browser)
  'Importing a module script failed'               // WebKit
]

export const CHUNK_RELOAD_COOLDOWN_MS = 30_000
const CHUNK_RELOAD_KEY = 'chunkLoadReloadAt'

export function isChunkLoadError(message: string | undefined): boolean {
  if (!message || typeof message !== 'string') return false
  return CHUNK_LOAD_ERROR_MESSAGES.some(m => message.includes(m))
}

/**
 * Reloads the page to pick up the current build, at most once per cooldown so a
 * chunk that is still missing after the reload cannot loop.
 * Returns true when a reload was started.
 */
export function reloadForChunkLoadError(
  storage: Storage = sessionStorage,
  reload: () => void = () => window.location.reload(),
  now: number = Date.now()
): boolean {
  try {
    const lastReload = Number(storage.getItem(CHUNK_RELOAD_KEY) ?? 0)
    if (now - lastReload < CHUNK_RELOAD_COOLDOWN_MS) return false
    storage.setItem(CHUNK_RELOAD_KEY, String(now))
  } catch {
    // Without storage the cooldown can't be enforced; don't risk a reload loop.
    return false
  }
  reload()
  return true
}
